// helpers/clone.ts or inside the component file
const stripDerivedFields = (state) => {
  const {
    // strip IDs and heavy/derived fields
    docId,
    pensionResults,
    investmentResults,
    incomeExpenditureResults,
    incomeExpenditureChartImages,
    surpluDeficitChartImages,
    pensionChartImages,
    investmentChartImages,
    combinedIncExpdChartImages,
    combinedSurDefChartImages,
    stackedPenChartImages,
    stackedInvChartImages,
    calculatedIncome,
    // also UI bits
    updatedOn,
    createdAt,
    createdBy,
    ...rest
  } = state || {};
  return rest;
};

export default stripDerivedFields;